const $ = window.jQuery;
const $window = window.$window || $(window);



const ScrollViewport = {

    init () {

      $(".scroll").click(function(event){
        //prevent the default action for the click event
        event.preventDefault();

        //get the full url - like mysitecom/index.htm#home
        var full_url = this.href;

        //split the url by # and get the anchor target name - home in mysitecom/index.htm#home
        var parts = full_url.split("#");
        var trgt = parts[1];

        //get the top offset of the target anchor
        var target_offset = $("#"+trgt).offset();
        var target_top = target_offset.top;

        //goto that anchor by setting the body scroll top to anchor top
        $('html, body').animate({scrollTop:target_top - 90}, 1500, 'easeInOutSine');
    });

    //   $.fn.isInViewport = function() {
    //     var elementTop = $(this).offset().top;
    //     //var elementBottom = elementTop + $(this).outerHeight();
      
    //     var viewportTop = $(window).scrollTop();
    //     var viewportBottom = viewportTop + $(window).height();
      
    //     //return elementBottom > (viewportTop + 400) && elementTop < (viewportBottom - 400);
    //     return elementTop < (viewportBottom - 400);
    //   };
      
    //   $(window).on('resize scroll', function() {
    //     $('.scrollviewport .item').each(function() {
    //         //var activeColor = $(this).attr('id');
    //       if ($(this).isInViewport()) {
    //         $(this).addClass('active');
    //       } else {
    //         $(this).removeClass('active');
    //       }
    //     });
    //   });
    }



};

export default ScrollViewport;